import qs from 'query-string';

const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  isNaN(value) ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const parse = (search) => {
  let queryParams = search;
  if (search === '' && window?.location?.search !== null) {
    queryParams = window.location.search;
  }

  return qs.parse(queryParams);
};

export const update = (search, newUrlParams) => {
  let urlParams = newUrlParams;

  const currentUrlParams = parse(search);
  const combinedParams = { ...currentUrlParams, ...urlParams };

  // if the query param is empty we don't need to display it in the url.
  const params = removeEmpty(combinedParams);
  return stringify(params);
};

export const stringify = (params) => qs.stringify(params);

export const removeAllParamsExcept = (currentParamsToVals, paramsToKeep) => {
  return Object.keys(currentParamsToVals)
    .filter((label) => paramsToKeep.includes(label))
    .reduce((acc, paramLabel) => {
      acc[paramLabel] = currentParamsToVals[paramLabel];
      return acc;
    }, {});
};

export const removeEmpty = (params) =>
  Object.keys(params).reduce((acc, key) => {
    const value = params[key];
    if (isEmpty(value)) return acc;
    acc[key] = value;
    return acc;
  }, {});

const queryString = {
  update,
  parse,
  stringify,
  removeEmpty
};

export default queryString;
